const mutations = {
  // Vertical NavMenu
  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value;
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width;
  },

  // UI
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width;
  },
};

export default mutations;
